import { Link,useNavigate } from "react-router-dom";
import React from "react";
import { Helmet } from "react-helmet";
import bg from '../assets/abs-bg.webp'
import bgmob from '../assets/abs-mob.webp'
import nf from '../assets/404.webp'
import {motion} from "framer-motion";
import info from '../assets/info.svg';

export default function NotFound() {

    const navigate = useNavigate(); 

    return (
        <motion.div 
        initial={{opacity:0}}
        animate={{opacity:1}}
        exit={{opacity:0}}
        transition={{duration:1}}
        className="overflow-hidden">
            <Helmet>
                <title>Not found • 404</title>
                <meta name="description" content="How it feels to see a 404 pag listed here :P"/>
            </Helmet>

            <div className="absolute w-[95%] pc flex text-slate-300 text-md font-light flex-row gap-10 justify-end p-5 m-6 mx-8">
                <Link to ="/"><h2 className="font-normal text-white hover:text-slate-200"><abbr title="About me in short">ABOUT</abbr></h2></Link>
                <Link to ="/projects"><h2 className="font-normal text-white hover:text-slate-200"><abbr title="List of projects, I've worked on">PROJECTS</abbr></h2></Link>
            </div>

            <div> 
                <img className="pc fixed bg-cover object-fill fixed  -z-10" src={bg}alt=''/>
                <img className="mob fixed bg-cover object-fill fixed  -z-10" src={bgmob}alt=''/>

                <div className="p-[5rem] flex flex-col justify-center items-center gap-[10em]">
                    <motion.img 
                        drag
                        dragElastic={0.5}
                        dragSnapToOrigin={1}
                        whileHover={{ scale: 1.03}}
                        whileTap={{ scale: 0.8}}
                        transition={{ duration: 0.5 }}
                    className=" top-[20%] cursor-move absolute w-[14em] object-contain" src={nf} />
                    <div className="absolute text-center mt-[5rem] bottom-[10%]">
                        <Link to="/"><button className="bg-white/10 backdrop-blur-xl text-white text-lg px-8 py-4 rounded-full drop-shadow-lgte"><motion.p 
                                    initial={{y:0}}
                                    whileHover={{y:-2}}
                                    whileTap={{scale:0.95}}>Go Home</motion.p></button></Link><br></br>
                        <button onClick={() => navigate(-1)} className="text-white text-lg px-8 py-6 underline">Back</button>
            <p className="relative bg-white/10 backdrop-blur-xl text-slate-200 flex flex-row gap-1 w-max text-xs px-4 py-2 rounded-full"><img src={info} alt=""/>Meanwhile play with the Blob :)</p>
                    </div>
                </div>
            </div>
            
        </motion.div>
    )
}